import React, { useContext } from 'react';

export interface RadioGroupContextValue {
  name: string;
  value: string | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  disabled: boolean;
}

/** Internal to `components/ui/`: what a RadioGroup hands its Radios. `null` outside a group. */
export const RadioGroupContext = React.createContext<RadioGroupContextValue | null>(null);

/** The enclosing RadioGroup's context, or `null` for a standalone Radio. */
export const useRadioGroup = () => useContext(RadioGroupContext);
